import { FlexColumn, FlexRow, useMatchMedia } from '@make-software/cspr-design';
import React, { PropsWithChildren } from 'react';
import styled from 'styled-components';

interface TileLayoutProps {
  side: React.ReactNode[];
}

export const StyledFlexColumn = styled(FlexColumn)(({ theme }) =>
  theme.withMedia({
    width: ['100%', '100%', '376px'],
    minWidth: ['100%', '100%', '376px'],
  })
);

export const TileLayout = ({
  side,
  children,
}: PropsWithChildren<TileLayoutProps>) => {
  const DynamicLayout = useMatchMedia(
    [FlexColumn, FlexColumn, FlexRow, FlexRow],
    []
  );

  return (
    <DynamicLayout gap={24}>
      <StyledFlexColumn gap={24}>{side}</StyledFlexColumn>
      {children}
    </DynamicLayout>
  );
};
